module.exports = __webpack_public_path__ + "static/media/violet.1e93678d.png";